(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-back-to-top"] && !Shopify.designMode) return;
  try {
    const backToTopButton = document.querySelector('[data-back-to-top]');

  backToTopButton?.addEventListener("click", event => {
    event.preventDefault();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-header-script"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.STICKY_CLASS = "header--sticky";

      this.header = this.querySelector("[data-header]");
      this.isTransparent = this.header.classList.contains("header--transparent");

      if (!this.isTransparent) document.body.classList.add("body--has-margin-top");

      this.init();
    }

    init() {
      window.addEventListener("scroll", () => this.onScroll(), { passive: true });

      this.onScroll();
    }

    onScroll() {
      window.scrollY > 0
        ? this.header.classList.add(this.STICKY_CLASS)
        : this.header.classList.remove(this.STICKY_CLASS);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["timeline-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const CLASS_ITEM_HIDDEN = "timeline__item--hidden";
    const CLASS_BUTTON_HIDDEN = "timeline__load-more--hidden";
    const section = document.querySelector("[data-timeline]");
    const button = section?.querySelector("[data-load-more-button]");
    const items = section?.querySelectorAll("[data-timeline-item]");
    const hideButton = () => button.classList.add(CLASS_BUTTON_HIDDEN);

    if (items && items.length <= 4) hideButton();

    button?.addEventListener("click", () => {
      const hiddenArray = Array.from(items).filter(item => item.classList.contains(CLASS_ITEM_HIDDEN));

      hiddenArray.slice(0, 4).forEach(item => item.classList.remove(CLASS_ITEM_HIDDEN));

      if (hiddenArray.length <= 4) hideButton();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-controls-script"] && !Shopify.designMode) return;
  try {
    class VideoControls extends HTMLElement {
    constructor() {
      super();

      this.PLAYING_CLASS = 'media__button--paused';
      this.MUTED_CLASS = 'media__button--muted';
    }

    connectedCallback() {
      this.addListeners();
      this.handleResize();
    }

    /**
    * Add event listeners to the button and resize observer
    */
    addListeners() {
      this.playStateButton.addEventListener("click", () => this.toggleMediaState("play"));
      this.muteStateButton.addEventListener("click", () => this.toggleMediaState("mute"));
      this.resizeObserver = new ResizeObserver(() => this.handleResize());
      this.resizeObserver.observe(document.body);
    }

    /**
    * Toggle video state based on current viewport (mobile or desktop)
    */
    toggleMediaState(type) {
      if (!this.videos.length) return;
      const sourceVideo = this.activeVideo || this.videos[0];

      // Derive one target state, then apply it to all videos.
      const forceState = type === "play" ? sourceVideo.paused : !sourceVideo.muted;

      this.videos.forEach(video => this.toggleVideoState(video, type, forceState));

      if (type === "play") {
        this.toggleVideoPlayButtonState(sourceVideo);
        return;
      }

      this.toggleVideoMuteButtonState(sourceVideo);
    }

    /**
    * Play or pause the video
    * @param {HTMLVideoElement} video - The video element to toggle
    * @param {string} type - The type of state to toggle ("play" or "mute")
    * @param {boolean} forceState - Optional explicit target state for sync
    */
    toggleVideoState(video, type, forceState) {
      type === "play" ? this.toggleVideoPlay(video, forceState) : this.toggleVideoMute(video, forceState);
    }

    /**
    * Play or pause the video
    * @param {HTMLVideoElement} video - The video element to toggle
    * @param {boolean} forceState - Optional explicit target state for sync
    */
    toggleVideoPlay(video, forceState) {
      this.toggleVideoPlayState(video, forceState);
    }

    /**
    * Play or pause the video
    * @param {HTMLVideoElement} video - The video element to toggle
    * @param {boolean} forceState - Optional explicit target state for sync
    */
    toggleVideoMute(video, forceState) {
      this.toggleVideoMuteState(video, forceState);
    }

    /**
    * Play or pause the video
    * @param {HTMLVideoElement} video - The video element to toggle
    * @param {boolean} forceState - Optional explicit target state for sync
    */
    toggleVideoPlayState(video, forceState) {
      const shouldPlay = typeof forceState === "boolean" ? forceState : video.paused;

      if (shouldPlay) {
        video.play()?.catch(() => null);
        return;
      }

      video.pause();
    }

    /**
    * Mute or unmute the video
    * @param {HTMLVideoElement} video - The video element to toggle
    * @param {boolean} forceState - Optional explicit target state for sync
    */
    toggleVideoMuteState(video, forceState) {
      video.muted = typeof forceState === "boolean" ? forceState : !video.muted;
    }

    /**
    * Toggle the play button state based on the video state
    * @param {HTMLVideoElement} video - The video element to check
    */
    toggleVideoPlayButtonState(video) {
      this.playStateButton.classList.toggle(this.PLAYING_CLASS, video.paused);
    }

    /**
    * Toggle the play button state based on the video state
    * @param {HTMLVideoElement} video - The video element to check
    */
    toggleVideoMuteButtonState(video) {
      this.muteStateButton.classList.toggle(this.MUTED_CLASS, video.muted);
    }

    handleResize() {
      this.videos.forEach(video => {
        const isMobileVideo = video.hasAttribute("data-media-player-mobile");

        if (video.readyState === 0) return;
        if (typeof video.play !== "function") return;

        if (this.isMobile && isMobileVideo) video.play()?.catch(() => null);
        else if (!this.isMobile && !isMobileVideo) video.play()?.catch(() => null);
      });
    }

    /**
    * Initialize the video controls
    */
    get media() {
      return this.closest("[data-media]");
    }

    /**
    * Get the play button element
    */
    get playStateButton() {
      return this.querySelector("[data-media-play-state-button]");
    }

    /**
    * Get the mute button element
    */
    get muteStateButton() {
      return this.querySelector("[data-media-mute-state-button]");
    }

    /**
    * Get all video elements within the media container
    */
    get videos() {
      return this.media.querySelectorAll("[data-media-player], [data-media-player-mobile]");
    }

    /**
    * Get the current active video based on viewport
    */
    get activeVideo() {
      return Array.from(this.videos).find(video => {
        const isMobileVideo = video.hasAttribute("data-media-player-mobile");
        return this.isMobile ? isMobileVideo : !isMobileVideo;
      });
    }

    /**
    * Determine if the current viewport is mobile
    */
    get isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }
  }

  customElements.define("video-controls", VideoControls);
  } catch(e) { console.error(e); }
})();

})();
